import styled from '@emotion/styled'
import mq from 'theme/mediaQueries'

export const Container = styled.div`
  ${mq({
    display: ['block', 'block', 'grid'],
    gridTemplateColumns: ['100px', 'auto 220px 220px', 'auto 300px 300px'],
  })}
`

export const GroupStock = styled.div`
  display: grid;
  grid-template-columns: 60% 40%;
`

export const GroupPrice = styled.div`
  display: grid;
  grid-template-columns: 80% 20%;
`
